// @flow
/* globals document, window */
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Button from "elevate-ui/Button";
import { stringify } from "querystring";
import assign from "lodash/assign";

import { withGlobalContext } from "../common/GlobalContext";
import GlobalAlert from "../common/GlobalAlert";
import ListingGrid from "../common/ListingGrid";
import NoListings from "../common/NoListings";
import OnboardNavigator from "../common/OnboardNavigator";

import type { $LocalListingViewModel } from "flow/types";

type Props = {
  alerts: Array<Object>,
  classes: Object,
  formType: void | "buy" | "sell",
  listings: $LocalListingViewModel[],
  title: string,
  onboardFilters: Object, // filters for onboard navigator
  searchFilters: Object,
};

const CommunityInfo = ({
  alerts,
  classes,
  listings,
  title,
  onboardFilters,
  searchFilters,
}: Props) => {
  return (
    <div className={classes.root}>
      <GlobalAlert alerts={alerts} />
      <div className={classes.flexCenter}>
        <Typography type="heading2" gutterTop gutterBottom>
          {title}
        </Typography>
      </div>

      <div className={classes.scrollableListings}>
        <ListingGrid
          listings={listings}
          zeroContent={<NoListings />}
          scrollX={true}
          withMargin={false}
        />
      </div>
      <div className={classes.flexCenter}>
        <Button
          onClick={() => {
            if (window) {
              window.location = `/listings?${stringify(
                assign({}, searchFilters, { offset: searchFilters.limit })
              )}`;
            }
          }}
        >
          More Listings
        </Button>
      </div>
      <OnboardNavigator filters={onboardFilters} />
    </div>
  );
};

export default withStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: "#fff !important",
    },
  },
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing.unit,
  },
  scrollableListings: {
    overflowX: "scroll",
    height: "390px",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
}))(withGlobalContext(CommunityInfo));
